const $inject = [];

const lbTooltipController = function () {
  let vm = this;
};

lbTooltipController.$inject = $inject;

export default lbTooltipController;



// WEBPACK FOOTER //
// ./src/directives/lbTooltip/lbTooltipController.js